import React from "react";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import CommunicatorPageComponents from "../components/core/shipments/CommonShipmentsComponents";
import {COMMUNICATOR_PAGE_PATH} from "../layouts/navigation/Navigator";
import {RecordVoiceOver} from "@material-ui/icons";
import queryString from 'query-string';
import {useLocation} from "react-router-dom";
import { normalizeToNumber, normalizeToString } from "../utils/QueryParamNormalizerUtils";

function CommunicatorPage() {


    const {t} = useTranslation();
    const {search} = useLocation();
    const {load, query, scroll} = queryString.parse(search);

    const [initLoad, setInitLoad] = React.useState(0);
    const [initQuery, setInitQuery] = React.useState('');
    const [initScroll, setInitScroll] = React.useState(0);

    React.useEffect(() => {
        setInitLoad(normalizeToNumber(load));
        setInitQuery(normalizeToString(query));
        setInitScroll(normalizeToNumber(scroll));
    }, [load, query, scroll]);


    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.communicator")}</title>
                <meta name="description" content={t("page.title.communicator")}/>
            </Helmet>

            <AuthenticatedUserLayout pageTitle={t("page.title.communicator")}>
                <CommunicatorPageComponents detailsPagePath={COMMUNICATOR_PAGE_PATH} Icon={<RecordVoiceOver/>}
                                            initLoad={initLoad} initQuery={initQuery} initScroll={initScroll}/>
            </AuthenticatedUserLayout>
        </AuthorizedContextProvider>
    );


}

export default CommunicatorPage;
